module.exports = __webpack_public_path__ + "assets/img/d4d8829c6d389c9357cc9ba2aa81c9bf.svg";